<template>
  <div class="maccontainer _maccontainer">
     <NavTop :navid = id />
     <div class="home_box">
        <img v-lazy="backimg" alt="" class="julihe_bannerimg">
        <div class="article_box">
           <div class="article_title">{{pname}}</div>
           <div class="article_p">{{ptitle}}</div>
           <div v-html="content" style="margin-top:2vh;width:94vw;margin-left:3vw;overflow:hidden;"></div>
        </div>
     </div>
  </div>
</template>

<script>
import NavTop from '../comcomponents/NavTop'
import {articlemsg} from '../../api/jslihe'
export default {
  name: '',
  components: {
    NavTop
  },
  data () {
    return {
      id: Number(this.$route.query.id),
      articleid: this.$route.query.articleid,
      pname: this.$route.query.name,
      backimg: this.$route.query.img,
      ptitle: '',
      content: ''
    }
  },
  watch: {
    $route: function (to, from) {
      console.log(to)
      console.log(from)
      if (to.path === from.path) {
        console.log(this.$route.query.id)
        this.id = this.$route.query.id
        this.articleid = this.$route.query.articleid
        this.pname = this.$route.query.name
        this.backimg = this.$route.query.img
        this.getlist()
      }
    }
  },
  mounted () {
    console.log(this.articleid)
    this.getlist()
  },
  methods: {
    getlist () {
      articlemsg({id: this.articleid}).then(res => {
        console.log(res)
        this.ptitle = res.data.post_excerpt
        this.content = res.data.post_content
      })
    }
  }
}
</script>

<style lang="less" scoped>
</style>



// WEBPACK FOOTER //
// src/components/Mac/Mac.vue